import { DefaultTheme } from 'styled-components';
import { RichTextEditorState } from './theme';

export const getStyles = (theme: DefaultTheme, state: RichTextEditorState) => {
    const { richTextEditor: { colors } } = theme;
    return colors[state];
};
